import React, { useState, useEffect, useRef } from "react";
import { Empty, Select, Space } from "antd";

import moment from "moment";
import dayjs from "dayjs";
import { Card, Col, Row, Tooltip, DatePicker, Tabs } from "antd";
import DoughNutChart from "../charts/DoughnutChart";
import PieChart from "../charts/PieChart";
import DistrictMap from "../charts/DistrictMap";
import ProvinceEventsMap from "../charts/ProvinceEventsMap";
import StackColumnChart from "../charts/StackColumnChart";

import Legend from "../charts/Legend";
import util from "../../utils/functions/custom";

import "antd/dist/reset.css";
import { InfoCircleTwoTone } from "@ant-design/icons";

import stemiAnalyticsService from "../../services/stemiAnalyticsService";
import {ReportTemplate} from "../custom/ReportTemplate";
import { reportTypeEnum } from "../custom/AppEnums";
import { ReportButtons } from "../custom/ReportButtons";

export const STEMIOlympiadReport = (props) => {
    const titleRef = useRef(null);
    const { reportType } = props;

    const tab1 = "Participants Demographic distribution";
    const tab2 = "Participants Sector distribution";
    const tab3 = "Olympiad Geographic distribution";
    const tab4 = "Participants Geographic distribution";

    const [participantRaceData, setParticipantRaceData] = useState([]);
    const [participantGenderData, setParticpantGenderData] = useState([]);
    const [participantSchoolTypeData, setParticipatantSchoolTypeData] = useState([] );
    const [participantDisabilityData, setParticipantDisabilityData] = useState([]);
    const [participantSectorData, setParticipantSectorData] = useState([]);
    const [municipalDistributionData, setMunicipalDistributionData] = useState([]);
    const [provincialParticipationData, setProvincialParticipationData] = useState([]);
    const [provincialDistributionData, setProvincialDistributionData] = useState([]);
    const [municipalParticipationData, setMunicipalParticipationData] = useState( []);
    const [olympiadSectorGenderData, setOlympiadSectorGenderData] = useState([]);
    const [olympiadSectorParticipantTotal, setOlympiadSectorParticipantTotal] =useState([]);
    const [olympiadSectorProvinceData, setOlympiadSectorProvinceData] = useState( []);

    const [olympiadSectorGradeData, setOlympiadSectorGradeData] = useState([]);
    const [stemiOlympiadRounds, setStemiOlympiadRounds] = useState([]);
    const [stemiOlympiadNames, setStemiOlympiadNames] = useState([]);

    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [olympiadRound, setOlympiadRound] = useState(-1);
    const [defaultCompetition, setDefaultCompetition] = useState(-1);
    const [defaultSector, setdefaultSector] = useState(-1);
    const [selectedSector, setSelectedSector] = useState(-1);
    const [stemiOlympiadSectors, setStemiOlympiadSectors] = useState([]);

    const [show, setShow] = useState(false);
    const [isGeo, setIsGeo] = useState(false);
    const [selectedCompetition, setSelectedCompetition] = useState(-1);
    const [reportOutProps, setReportOutProps] = useState({
        data: [],
        color: "",
        type: "",
        year: 0,
        description: "",
        xLabel: "",
        yLabel: "",
        dataSource: "",
        seriesField: "",
        isStack: false,
        xField: "",
    });

    const [reportYear, setReportYear] = useState(util.getCurrentRepotYear());
    const [financialYears, setFinancialYears] = useState(util.getCurrentFinancialYear());
    const [currentDate, setcurrentDate] = useState(dayjs(Date()));
    const { Option } = Select;
    const olympiadProvincialDistribution = "Distribution of Olympiads by Province";
    const olympiadMunicialDistribution = "Distribution of Olympiads by Municipal District";
    const olympiadProvincialParticipation = "Distribution of participants by Province";
    const olympiadMunicipalParticipation = "Distribution of participants by Municipal District";

    const monthFormat = 'YYYY'

    useEffect(() => {
        setStartDate(reportYear);
        setEndDate(reportYear);
        getYearRange();
        getStemiOlympiadRounds();
        getStemiOlympiadNames();
        getStemiOlympiadSectors();
    }, [reportType]);

    const processResponse = (response, setterFunction) => {
        if (response && response.status === 200) {
            const { data } = response;
            setterFunction(data);
        }
        else {
            setterFunction([]);
        }
    }

    const getStemiOlympiadNames = async () => {
        try {
            const response = await stemiAnalyticsService.getStemiOlympiadNames();
            if (response && response.status === 200) {
                const { data } = response;
                const allOlympiads = { key: -1, value: "All Olympiads" };
                data.unshift(allOlympiads);
                setStemiOlympiadNames(data);
            } else {
                // response.status == 204
                setStemiOlympiadNames([]);
            }
        }
        catch (error) { }
    };

    const getYearRange = async () => {
        try {
            const response = await stemiAnalyticsService.getYearRange();
            if (response && response.status == 200) {
                const { data } = response;
                setStartDate(data.startYear);
                setEndDate(data.endYear);
                const finYears = util.getFinancialYearRange(data.startYear, data.endYear);
                setFinancialYears(finYears);
                if (reportYear !== data.endYear) {
                    setReportYear(data.endYear);
                }
                updateAnalytics({ year: data.endYear, round: olympiadRound, competition: defaultCompetition, sector: defaultSector });

            } else {
                setStartDate(util.getCurrentRepotYear());
                setEndDate(util.getCurrentRepotYear());
            }
        } catch (error) { }
    };

    const getStemiOlympiadRounds = async () => {
        try {
            const response = await stemiAnalyticsService.getStemiRounds();
            if (response && response.status === 200) {
                const { data } = response;
                const allRounds = { key: -1, value: "All Rounds" };
                const sortData = data.sort((a,b)=>a.key - b.key);
                sortData.unshift(allRounds);
                setStemiOlympiadRounds(sortData);
            } else {
                // response.status == 204
                setStemiOlympiadRounds([]);
            }
        } catch (error) {
            console.log("ERROR", error);
        }
    };

    const getStemiOlympiadSectors = async () => {
        try {
            const response = await stemiAnalyticsService.getStemiSectors();;
             if (response && response.status === 200) {
                const { data } = response;
                const allSectors = { key: -1, value: "All Sectors" };
                data.unshift(allSectors);
                setStemiOlympiadSectors(data);
            }
        }
        catch (error) {
            console.log("Sector error " + error);
         }
    };

    const getOlympiadSectorParticipantTotal = async (year, round, competition, sector) => {

        try {
            const response = await stemiAnalyticsService.getOlympiadSectorGender({ year: year, roundId: round, competition: competition, sector: sector });

            if (response && response.status == 200) {
                const { data } = response;

                const sectorTotals = data.reduce((sectors, { group, value }) => {
                    if (!sectors[group]) {
                        sectors[group] = {
                            group,
                            value: 0,
                        };
                    }
                    sectors[group].value += value;
                    return sectors;
                }, {});

                setOlympiadSectorParticipantTotal(sectorTotals);
            } else {
                // response.status == 204
                setOlympiadSectorParticipantTotal({});
            }
        } catch (error) { }
    };

    const getOlympiadSectorProvinceData = async (year, round, competition, sector) => {
        try {
            const response = await stemiAnalyticsService.getOlympiadSectorProvince({ year: year, roundId: round, competition: competition, sector: sector });
            processResponse(response, setOlympiadSectorProvinceData);
        } catch (error) { }
    };

    const getOlympiadSectorGradeData = async (year, round, competition, sector) => {
        try {
            const response = await stemiAnalyticsService.getOlympiadSectorGrade({ year: year, roundId: round, competition: competition, sector: sector });
            if (response && response.status == 200) {
                const { data } = response;
                let aN, bN;
                data.sort(function (a, b) {
                    aN = a.type.split("Gr")[1];
                    bN = b.type.split("Gr")[1];
                    return aN - bN;
                });
                setOlympiadSectorGradeData(data);
            } else {
                // response.status == 204
                setOlympiadSectorGradeData([]);
            }
        } catch (error) { }
    };

    const getOlympiadSectorGenderData = async (year, round, competition = selectedCompetition, sector = selectedSector) => {
        try {
            const response = await stemiAnalyticsService.getOlympiadSectorGender({ year: year, roundId: round, competition: competition, sector: sector });
            processResponse(response, setOlympiadSectorGenderData);
        } catch (error) { }
    };

    const getParticipantSectorData = async (year, round, competition = selectedCompetition, sector = selectedSector) => {
        try {
            const response = await stemiAnalyticsService.getParticipantSector({ year: year, roundId: round, competition: competition, sector: sector });
            processResponse(response, setParticipantSectorData);
        } catch (error) { }
    };

    const getParticipantSchoolTypeData = async (year, round, competition = selectedCompetition, sector = selectedSector) => {
        try {
            const response = await stemiAnalyticsService.getParticipantSchoolType({ year: year, roundId: round, competition: competition, sector: sector });
            processResponse(response, setParticipatantSchoolTypeData);
        } catch (error) { }
    };

    const getParticipantRaceData = async (year, round, competition = selectedCompetition, sector = selectedSector) => {
        try {
            const response = await stemiAnalyticsService.getParticipantRace({ year: year, roundId: round, competition: competition, sector: sector });
            processResponse(response, setParticipantRaceData);
        } catch (error) { }
    };

    const getParticipantGenderData = async (year, round, competition = selectedCompetition, sector = selectedSector) => {
        try {
            const response = await stemiAnalyticsService.getParticipantGender({ year: year, roundId: round, competition: competition, sector: sector });
            processResponse(response, setParticpantGenderData);
        } catch (error) { }
    };

    const getParticipantDisabilityData = async (year, round, competition = selectedCompetition, sector = selectedSector) => {
        try {
            const response = await stemiAnalyticsService.getParticipantDisability({ year: year, roundId: round, competition: competition, sector: sector });
            processResponse(response, setParticipantDisabilityData);
        } catch (error) { }
    };

    const getProvincialDistributionData = async (year, round, competition = selectedCompetition, sector = selectedSector) => {
        try {
            const response = await stemiAnalyticsService.getOlympiadProvince({ year: year, roundId: round, competition: competition, sector: sector });
            processResponse(response, setProvincialDistributionData);
        } catch (error) { }
    };

    const getMunicipalDistributionData = async (year, round, competition = selectedCompetition, sector = selectedSector) => {
        try {
            const response = await stemiAnalyticsService.getOlympiadDistrict({ year: year, roundId: round, competition: competition, sector: sector });
            processResponse(response, setMunicipalDistributionData);
        } catch (error) { }
    };

    const getProvincialParticipationData = async (year, round, competition = selectedCompetition, sector = selectedSector) => {
        try {
            const response = await stemiAnalyticsService.getParticipantProvince({ year: year, roundId: round, competition: competition, sector: sector });
            processResponse(response, setProvincialParticipationData);
        } catch (error) { }
    };

    const getMunicipalParticipationData = async (year, round, competition = selectedCompetition, sector = selectedSector) => {
        try {
            const response = await stemiAnalyticsService.getParticipantDistrict({ year: year, roundId: round, competition: competition, sector: sector });
            processResponse(response, setMunicipalParticipationData);
        } catch (error) { }
    };

    const updateAnalytics = ({ year = reportYear, round = olympiadRound, competition = selectedCompetition, sector = selectedSector }) => {

        if (props.reportType === "Overview") {
            getOlympiadSectorParticipantTotal(year, round, competition, sector);
            getOlympiadSectorProvinceData(year, round, competition, sector);
            getOlympiadSectorGradeData(year, round, competition, sector);
            getOlympiadSectorGenderData(year, round, competition, sector);
            getParticipantSectorData(year, round, competition, sector);
        }
        getParticipantSchoolTypeData(year, round, competition, sector);
        getParticipantRaceData(year, round, competition, sector);
        getParticipantGenderData(year, round, competition, sector);
        getParticipantDisabilityData(year, round, competition, sector);
        getProvincialDistributionData(year, round, competition, sector);
        getMunicipalDistributionData(year, round, competition, sector);
        getProvincialParticipationData(year, round, competition, sector);
        getMunicipalParticipationData(year, round, competition, sector);
    };

    const onYearChange = (value) => {
        setReportYear(value);
        setcurrentDate(dayjs(value))
        const defaultSector = "-1";
        updateAnalytics({ year: value, round: olympiadRound, competition: defaultCompetition, sector: defaultSector });
    };

    const onChangeRound = (selected) => {
        const selectedRound = stemiOlympiadRounds.find((record) => record.value === selected);
        setOlympiadRound(selectedRound?.key);
        updateAnalytics({ year: reportYear, round: selectedRound.key, competition: defaultCompetition, sector: defaultSector });

    };

    const onChangeSector = (selected) => {
        const selectedItem = stemiOlympiadSectors.find((record) => record.value === selected);
        setSelectedSector(selectedItem?.key)
        updateAnalytics({ year: reportYear, round: olympiadRound, competition: defaultCompetition, sector: selectedItem?.key });
    };

    const onChangeOlympiad = (selected) => {
        const selectedItem = stemiOlympiadNames.find((record) => record.value === selected);
        setSelectedCompetition([]);
        setSelectedCompetition(selectedItem?.key)
        updateAnalytics({ year: reportYear, round: olympiadRound, competition: selectedItem?.key, sector: defaultSector });
    };

    // Disable some dates on the picker based on start and end dates
    const disabledDate = (current) => {
        return (
            current &&
            (current.valueOf() >= moment(endDate + 1, "YYYY") ||
                current.valueOf() <= moment(startDate, "YYYY"))
        );
    };

    const handlePrint = (
        color,
        data,
        type,
        desc,
        title,
        xLabel = "None",
        yLabel = "None",
        seriesField = "None",
        isStack = false,
        xField = "None",
    ) => {
        const rptProps = { ...reportOutProps };
        rptProps.title = title;
        rptProps.description = desc;
        rptProps.color = color;
        rptProps.data = data;
        rptProps.type = type;
        rptProps.year = reportYear ? reportYear : 0;
        rptProps.xLabel = xLabel;
        rptProps.yLabel = yLabel;
        rptProps.seriesField = seriesField;
        rptProps.isStack = isStack;
        rptProps.xField = xField;

        setReportOutProps(rptProps);
        setShow(true);
        setIsGeo(false);
    };

    const handleGeoPrint = (title, description, data, geoType, dataSource) => {
        const rptProps = { ...reportOutProps };
        rptProps.title = title;
        rptProps.description = description;
        rptProps.color = undefined;
        rptProps.data = data;
        rptProps.type = geoType;
        rptProps.year = reportYear ? reportYear : 0;
        rptProps.dataSource = dataSource;

        setReportOutProps(rptProps);
        setShow(true);
        setIsGeo(true);
    };

    const handleDataDownload = (data, filename, chartType) => {
        let csvContent;

        if (chartType === reportTypeEnum.GROUPCOL) {
            const groupedData = util.groupDataByType(data, reportYear);

            csvContent = "data:text/csv;charset=utf-8," + util.convertArrayDataToCSV(groupedData);
        } else {
            csvContent = "data:text/csv;charset=utf-8," + util.convertArrayDataToCSV(data);
        }

        const encodedURI = encodeURI(csvContent);
        //Allow the selected to be downloadable through an anchor popup
        const link = document.createElement("a");
        link.setAttribute("href", encodedURI);
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handlePrintCancel = () => {
        setShow(false);
        setIsGeo(false);
        const rptProps = { ...reportOutProps };
        rptProps.title = "";
        rptProps.description = "";
        rptProps.color = undefined;
        rptProps.data = [];
        rptProps.type = undefined;
        rptProps.year = 0;
        rptProps.dataSource = "";
        setReportOutProps(rptProps);
    };

    function Tab1() {
        return (
            <div className="report-content">
                {/* <Row style={{ paddingBottom: 10 }} gutter={16}>
                    <Col xs={24} md={8}>
                        <Card
                            title="Participants Disability Distribution"
                            bordered={false}
                            extra={
                                <Tooltip title="Demographic analysis of Olympiads, based on disability.">
                                    <InfoCircleTwoTone />
                                </Tooltip>
                            }
                            actions={
                                participantDisabilityData.length > 0 && [
                                    <ReportButtons
                                        onPrint={() =>
                                            handlePrint(
                                                "demographicPie",
                                                participantDisabilityData,
                                                reportTypeEnum.PIE,
                                                "Demographic analysis of Olympiads, based on disability.",
                                                "Participants Disability Distribution"
                                            )
                                        }
                                        onDownload={() =>
                                            handleDataDownload(
                                                participantDisabilityData,
                                                "Participants Disability Distribution",
                                                reportTypeEnum.PIE
                                            )
                                        }
                                    />,
                                ]
                            }
                        >
                            {participantDisabilityData.length === 0 ? (
                                <Empty />
                            ) : (
                                <PieChart
                                    data={participantDisabilityData.filter(item => item.value > 0)}
                                    color="demographicPie"
                                />
                            )}
                        </Card>
                    </Col>
                    <Col xs={24} md={8}>
                        <Card
                            title="Participants Race Distribution"
                            bordered={false}
                            extra={
                                <Tooltip title="Demographic analysis of Olympiads, based on race.">
                                    <InfoCircleTwoTone />
                                </Tooltip>
                            }
                            actions={
                                participantRaceData.length > 0 && [
                                    <ReportButtons
                                        onPrint={() =>
                                            handlePrint(
                                                "ageDougnut",
                                                participantRaceData,
                                                reportTypeEnum.DOUGHNUT,
                                                "Demographic analysis of Olympiads, based on race.",
                                                "Participants Race Distribution"
                                            )
                                        }
                                        onDownload={() =>
                                            handleDataDownload(
                                                participantRaceData,
                                                "Participants Race Distribution",
                                                reportTypeEnum.DOUGHNUT
                                            )
                                        }
                                    />,
                                ]
                            }
                        >
                            {participantRaceData.length === 0 ? (
                                <Empty />
                            ) : (
                                <DoughNutChart data={participantRaceData.filter(item => item.value > 0)} color="ageDougnut" />
                            )}
                        </Card>
                    </Col>
                    <Col xs={24} md={8}>
                        <Card
                            title="Participants Gender Distribution"
                            bordered={false}
                            extra={
                                <Tooltip title="Demographic analysis of Olympiads, based on gender.">
                                    <InfoCircleTwoTone />
                                </Tooltip>
                            }
                            actions={
                                participantGenderData.length > 0 && [
                                    <ReportButtons
                                        onPrint={() =>
                                            handlePrint(
                                                "demographicPie",
                                                participantGenderData,
                                                reportTypeEnum.PIE,
                                                "Demographic analysis of Olympiads, based on gender.",
                                                "Participants Gender Distribution"
                                            )
                                        }
                                        onDownload={() =>
                                            handleDataDownload(
                                                participantGenderData,
                                                "articipants Gender Distribution",
                                                reportTypeEnum.PIE
                                            )
                                        }
                                    />,
                                ]
                            }
                        >
                            {participantGenderData.length === 0 ? (
                                <Empty />
                            ) : (
                                <PieChart data={participantGenderData.filter(item => item.value > 0)} color="demographicPie" />
                            )}
                        </Card>
                    </Col>
                </Row> */}
                {props.reportType === "Overview" && (
                  <> 
                   <Row style={{ paddingBottom: 10 }} gutter={16}>
                    <Col xs={24} md={8}>
                        <Card
                            title="Participants Disability Distribution"
                            bordered={false}
                            style={{ height: "auto", width: "auto" }}
                            extra={
                                <Tooltip title="Demographic analysis of Olympiads, based on disability.">
                                    <InfoCircleTwoTone />
                                </Tooltip>
                            }
                            actions={
                                participantDisabilityData.length > 0 && [
                                    <ReportButtons
                                        onPrint={() =>
                                            handlePrint(
                                                "csGender",
                                                participantDisabilityData,
                                                reportTypeEnum.PIE,
                                                "Demographic analysis of Olympiads, based on disability.",
                                                "Participants Disability Distribution"
                                            )
                                        }
                                        onDownload={() =>
                                            handleDataDownload(
                                                participantDisabilityData,
                                                "Participants Disability Distribution",
                                                reportTypeEnum.PIE
                                            )
                                        }
                                    />,
                                ]
                            }
                        >
                            {participantDisabilityData.length === 0 ? (
                                <Empty />
                            ) : (
                                <PieChart
                                    data={participantDisabilityData.filter(item => item.value > 0)}
                                    color="csGender" type ="Disability"
                                />
                            )}
                        </Card>
                    </Col>
                    <Col xs={24} md={8}>
                        <Card
                            title="Participants Race Distribution"
                            bordered={false}
                            style={{ height: "auto",  width: "auto" }}
                            extra={
                                <Tooltip title="Demographic analysis of Olympiads, based on race.">
                                    <InfoCircleTwoTone />
                                </Tooltip>
                            }
                            actions={
                                participantRaceData.length > 0 && [
                                    <ReportButtons
                                        onPrint={() =>
                                            handlePrint(
                                                "ageDougnut",
                                                participantRaceData,
                                                reportTypeEnum.DOUGHNUT,
                                                "Demographic analysis of Olympiads, based on race.",
                                                "Participants Race Distribution"
                                            )
                                        }
                                        onDownload={() =>
                                            handleDataDownload(
                                                participantRaceData,
                                                "Participants Race Distribution",
                                                reportTypeEnum.DOUGHNUT
                                            )
                                        }
                                    />,
                                ]
                            }
                        >
                            {participantRaceData.length === 0 ? (
                                <Empty />
                            ) : (
                                <DoughNutChart data={participantRaceData.filter(item => item.value > 0)} color="ageDougnut" type ="Race" />
                            )}
                        </Card>
                    </Col>
                    <Col xs={24} md={8}>
                        <Card
                            title="Participants Gender Distribution"
                            bordered={false}
                            style={{ height: "auto",  width: "auto" }}
                            extra={
                                <Tooltip title="Demographic analysis of Olympiads, based on gender.">
                                    <InfoCircleTwoTone />
                                </Tooltip>
                            }
                            actions={
                                participantGenderData.length > 0 && [
                                    <ReportButtons
                                        onPrint={() =>
                                            handlePrint(
                                                "stemiGenderPie",
                                                participantGenderData,
                                                reportTypeEnum.PIE,
                                                "Demographic analysis of Olympiads, based on gender.",
                                                "Participants Gender Distribution"
                                            )
                                        }
                                        onDownload={() =>
                                            handleDataDownload(
                                                participantGenderData,
                                                "articipants Gender Distribution",
                                                reportTypeEnum.PIE
                                            )
                                        }
                                    />,
                                ]
                            }
                        >
                            {participantGenderData.length === 0 ? (
                                <Empty />
                            ) : (
                                <PieChart data={participantGenderData.filter(item => item.value > 0)} color="stemiGenderPie" type ="Gender"/>
                            )}
                        </Card>
                    </Col>
                </Row>
                <Row style={{ paddingBottom: 10 }} gutter={16}>
                     <Col xs={24} md={12}>
                        <Card
                            title="Participants Sector Distribution"
                            bordered={false}
                            style={{ height: "auto" }}
                            extra={
                                <Tooltip title="Demographic analysis of Olympiads, based on sector.">
                                    <InfoCircleTwoTone />
                                </Tooltip>
                            }
                            actions={
                                participantSectorData.length > 0 && [
                                    <ReportButtons
                                        onPrint={() =>
                                            handlePrint(
                                                "stemiSectorPie",
                                                participantSectorData,
                                                reportTypeEnum.PIE,
                                                "Demographic analysis of Olympiads, based on sector.",
                                                "Participants Sector Distribution"
                                            )
                                        }
                                        onDownload={() =>
                                            handleDataDownload(
                                                participantSectorData,
                                                "Participants Sector Distribution",
                                                reportTypeEnum.PIE
                                            )
                                        }
                                    />,
                                ]
                            }
                        >
                            {participantSectorData.length === 0 ? (
                                <Empty />
                            ) : (
                                <PieChart data={participantSectorData.filter(item => item.value > 0)} color="stemiSectorPie" type ="Sector"/>
                            )}
                        </Card>
                    </Col> 

                    <Col xs={24} md={12}>
                        <Card
                            title="School Type Distribution"
                            bordered={false}
                            style={{ height: "auto" }}
                            extra={
                                <Tooltip title="Demographic analysis of Olympiads, based on school type.">
                                    <InfoCircleTwoTone />
                                </Tooltip>
                            }
                            actions={
                                participantSchoolTypeData.length > 0 && [
                                    <ReportButtons
                                        onPrint={() =>
                                            handlePrint(
                                                "ageDougnut",
                                                participantSchoolTypeData,
                                                reportTypeEnum.DOUGHNUT,
                                                "Demographic analysis of Olympiads, based on school type.",
                                                "School Type Distribution"
                                            )
                                        }
                                        onDownload={() =>
                                            handleDataDownload(
                                                participantSchoolTypeData,
                                                "School Type Distribution",
                                                reportTypeEnum.DOUGHNUT
                                            )
                                        }
                                    />,
                                ]
                            }
                        >
                            {participantSchoolTypeData.length === 0 ? (
                                <Empty />
                            ) : (
                                <DoughNutChart
                                    data={participantSchoolTypeData.filter(item => item.value > 0)}
                                    color="ageDougnut" type ="School Type"
                                />
                            )}
                        </Card>
                    </Col>
                </Row>
                 </> 
                )} 

                  {props.reportType !== "Overview" && (
                    <>
                     <Row style={{ paddingBottom: 10 }} gutter={16}>
                        <Col xs={24} md={12}>
                            <Card
                            title="Participants Disability Distribution"
                            bordered={false}
                            style={{ height: "auto" }}
                            extra={
                                <Tooltip title="Demographic analysis of Olympiads, based on disability.">
                                    <InfoCircleTwoTone />
                                </Tooltip>
                            }
                            actions={
                                participantDisabilityData.length > 0 && [
                                    <ReportButtons
                                        onPrint={() =>
                                            handlePrint(
                                                "csGender",
                                                participantDisabilityData,
                                                reportTypeEnum.PIE,
                                                "Demographic analysis of Olympiads, based on disability.",
                                                "Participants Disability Distribution"
                                            )
                                        }
                                        onDownload={() =>
                                            handleDataDownload(
                                                participantDisabilityData,
                                                "Participants Disability Distribution",
                                                reportTypeEnum.PIE
                                            )
                                        }
                                    />,
                                ]
                            }
                        >
                            {participantDisabilityData.length === 0 ? (
                                <Empty />
                            ) : (
                                <PieChart
                                    data={participantDisabilityData.filter(item => item.value > 0)}
                                    color="csGender" type ="Disability"
                                />
                            )}
                            </Card>
                        </Col>
                        <Col xs={24} md={12}>
                            <Card
                            title="Participants Race Distribution"
                            bordered={false}
                            style={{ height: "auto" }}
                            extra={
                                <Tooltip title="Demographic analysis of Olympiads, based on race.">
                                    <InfoCircleTwoTone />
                                </Tooltip>
                            }
                            actions={
                                participantRaceData.length > 0 && [
                                    <ReportButtons
                                        onPrint={() =>
                                            handlePrint(
                                                "ageDougnut",
                                                participantRaceData,
                                                reportTypeEnum.DOUGHNUT,
                                                "Demographic analysis of Olympiads, based on race.",
                                                "Participants Race Distribution"
                                            )
                                        }
                                        onDownload={() =>
                                            handleDataDownload(
                                                participantRaceData,
                                                "Participants Race Distribution",
                                                reportTypeEnum.DOUGHNUT
                                            )
                                        }
                                    />,
                                ]
                            }
                        >
                            {participantRaceData.length === 0 ? (
                                <Empty />
                            ) : (
                                <DoughNutChart data={participantRaceData.filter(item => item.value > 0)} color="ageDougnut" type ="Race"/>
                            )}
                            </Card>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col xs={24} md={12}>
                            <Card
                            title="Participants Gender Distribution"
                            bordered={false}
                            style={{ height: "auto" }}
                            extra={
                                <Tooltip title="Demographic analysis of Olympiads, based on gender.">
                                    <InfoCircleTwoTone />
                                </Tooltip>
                            }
                            actions={
                                participantGenderData.length > 0 && [
                                    <ReportButtons
                                        onPrint={() =>
                                            handlePrint(
                                                "stemiGenderPie",
                                                participantGenderData,
                                                reportTypeEnum.PIE,
                                                "Demographic analysis of Olympiads, based on gender.",
                                                "Participants Gender Distribution"
                                            )
                                        }
                                        onDownload={() =>
                                            handleDataDownload(
                                                participantGenderData,
                                                "articipants Gender Distribution",
                                                reportTypeEnum.PIE
                                            )
                                        }
                                    />,
                                ]
                            }
                        >
                            {participantGenderData.length === 0 ? (
                                <Empty />
                            ) : (
                                <PieChart data={participantGenderData.filter(item => item.value > 0)} color="stemiGenderPie" type ="Gender"/>
                            )}
                            </Card>
                        </Col>
                        <Col xs={24} md={12}>
                            <Card
                            title="School Type Distribution"
                            bordered={false}
                            style={{ height: "auto" }}
                            extra={
                                <Tooltip title="Demographic analysis of Olympiads, based on school type.">
                                    <InfoCircleTwoTone />
                                </Tooltip>
                            }
                            actions={
                                participantSchoolTypeData.length > 0 && [
                                    <ReportButtons
                                        onPrint={() =>
                                            handlePrint(
                                                "ageDougnut",
                                                participantSchoolTypeData,
                                                reportTypeEnum.DOUGHNUT,
                                                "Demographic analysis of Olympiads, based on school type.",
                                                "School Type Distribution"
                                            )
                                        }
                                        onDownload={() =>
                                            handleDataDownload(
                                                participantSchoolTypeData,
                                                "School Type Distribution",
                                                reportTypeEnum.DOUGHNUT
                                            )
                                        }
                                    />,
                                ]
                            }
                        >
                            {participantSchoolTypeData.length === 0 ? (
                                <Empty />
                            ) : (
                                <DoughNutChart
                                    data={participantSchoolTypeData.filter(item => item.value > 0)}
                                    color="ageDougnut" type ="School Type"
                                />
                            )}
                            </Card>
                        </Col>
                    </Row> 
                </>

                )}

            </div>
        );
    }

    function Tab2() {
        return (
            <div className="report-content">
                <Row style={{ paddingBottom: 10 }} className="stemi-icons">
                    <Col sm={24} md={6}>
                        <Card className="green" bordered={false}  style={{ height: "auto" }}>
                            <Row>
                                <Col span={16}>
                                    <h3>Total participants in Innovation</h3>
                                    <div>
                                        {olympiadSectorParticipantTotal["Innovation"]
                                            ? olympiadSectorParticipantTotal["Innovation"].value
                                            : 0}
                                    </div>
                                </Col>
                                <Col span={8} align="middle">
                                    <img src={require("../../assets/innovation-icon.png")} />
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                    <Col sm={24} md={6}>
                        <Card className="blue1" bordered={false}  style={{ height: "auto" }}>
                            <Row>
                                <Col span={16}>
                                    <h3>Total participants in Mathematics</h3>
                                    <div>
                                        {olympiadSectorParticipantTotal["Mathematics"]
                                            ? olympiadSectorParticipantTotal["Mathematics"].value
                                            : 0}
                                    </div>
                                </Col>
                                <Col span={8} align="middle">
                                    <img src={require("../../assets/math-icon.png")} />
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                    <Col sm={24} md={6}>
                        <Card className="blue2" bordered={false}  style={{ height: "auto" }}>
                            <Row>
                                <Col span={16}>
                                    <h3>Participants in Robotics and Coding</h3>
                                    <div>
                                        {olympiadSectorParticipantTotal["Robotics and Coding"]
                                            ? olympiadSectorParticipantTotal["Robotics and Coding"]
                                                .value
                                            : 0}
                                    </div>
                                </Col>
                                <Col span={8} align="middle">
                                    <img src={require("../../assets/robot-icon.png")} />
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                    <Col sm={24} md={6}>
                        <Card className="purple1" bordered={false}  style={{ height: "auto" }}>
                            <Row>
                                <Col span={16}>
                                    <h3>Total participants in Science</h3>
                                    <div>
                                        {olympiadSectorParticipantTotal["Science"]
                                            ? olympiadSectorParticipantTotal["Science"].value
                                            : 0}
                                    </div>
                                </Col>
                                <Col span={8} align="middle">
                                    <img src={require("../../assets/science-icon.png")} />
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>

                <Row style={{ paddingBottom: 10 }} gutter={16}>
                    <Col xs={24} md={12}>
                        <Card
                            title="Participants per Province"
                            bordered={false}
                            style={{ height: "auto" }}
                            ref={titleRef}
                            extra={
                                <Space>
                                    <Tooltip title="Number of participants per province.">
                                        <InfoCircleTwoTone />
                                    </Tooltip>
                                </Space>
                            }
                            actions={
                                olympiadSectorProvinceData.length > 0 && [
                                    <ReportButtons
                                        onPrint={() =>
                                            handlePrint(
                                                "stemiProvince",
                                                olympiadSectorProvinceData,
                                                reportTypeEnum.GROUPCOL,
                                                "Number of participants per province.",
                                                "Participants per Province",
                                                "Province",
                                                "No of participants",
                                                "group",
                                                true,
                                                "type"
                                            )
                                        }
                                        onDownload={() =>
                                            handleDataDownload(
                                                olympiadSectorProvinceData,
                                                "Participants per Province",
                                                reportTypeEnum.GROUPCOL
                                            )
                                        }
                                    />,
                                ]
                            }
                        >
                            {olympiadSectorProvinceData.length === 0 ? (
                                <Empty />
                            ) : (
                                <>
                                    <StackColumnChart
                                        data={olympiadSectorProvinceData.filter(item => item.value > 0)}
                                        xField="type"
                                        yLabel="value"
                                        series="group"
                                        yAxisLabel="No of participants"
                                        xAxisLabel="Province"
                                        color="stemiProvince"
                                        colorField="type"
                                    />
                                </>
                            )}
                        </Card>
                    </Col>
                     <Col xs={24} md={12}>
                        <Card
                            title="Participants by gender"
                            bordered={false}
                            style={{ height: "auto" }}
                            extra={
                                <Tooltip title="Number of participants per type and gender.">
                                    <InfoCircleTwoTone />
                                </Tooltip>
                            }
                            actions={
                                olympiadSectorGenderData.length > 0 && [
                                    <ReportButtons
                                        onPrint={() =>
                                            handlePrint(
                                                "stemi",
                                                olympiadSectorGenderData,
                                                reportTypeEnum.GROUPCOL,
                                                "Number of participants per gender.",
                                                "Participants per Gender",
                                                "Gender",
                                                "No of participants",
                                                "group",
                                                true,
                                                "type"
                                            )
                                        }
                                        onDownload={() =>
                                            handleDataDownload(
                                                olympiadSectorGenderData,
                                                "Participants per Gender",
                                                reportTypeEnum.GROUPCOL
                                            )
                                        }
                                    />,
                                ]
                            }
                        >
                            {olympiadSectorGenderData.length === 0 ? (
                                <Empty />
                            ) : (
                                <StackColumnChart
                                    data={olympiadSectorGenderData.filter(item => item.value > 0)}
                                    color="stemi"
                                    xField="type"
                                    yLabel="value"
                                    series="group"
                                    yAxisLabel="No of participants"
                                    xAxisLabel="Gender"
                                    isStack={true}
                                />
                                // <GroupColumnChart color="event_organizer" data={olympiadSectorGenderData} xLabel='type' yLabel='value' series='group' yAxisLabel="Olympiads" xAxisLabel="Gender" />
                            )}
                        </Card>
                    </Col>
                </Row>

                <Row style={{ paddingBottom: 10, marginTop: 16 }} gutter={16}>
                    <Col xs={24}>
                        <Card
                            title="Participants per Grade"
                            bordered={false}
                            style={{ height: "auto" }}
                            extra={
                                <Tooltip title="Number of participants per grade.">
                                    <InfoCircleTwoTone />
                                </Tooltip>
                            }
                            actions={
                                olympiadSectorGradeData.length > 0 && [
                                    <ReportButtons
                                        onPrint={() =>
                                            handlePrint(
                                                "stemiGrade",
                                                olympiadSectorGradeData,
                                                reportTypeEnum.GROUPCOL,
                                                "Number of participants per grade.",
                                                "Participants per Grade",
                                                "Grade",
                                                "No of participants",
                                                "group",
                                                true,
                                                "type"
                                            )
                                        }
                                        onDownload={() =>
                                            handleDataDownload(
                                                olympiadSectorGradeData,
                                                "Participants per Grade",
                                                reportTypeEnum.GROUPCOL
                                            )
                                        }
                                    />,
                                ]
                            }
                        >
                            {olympiadSectorGradeData.length === 0 ? (
                                <Empty />
                            ) : (
                                <StackColumnChart
                                    data={olympiadSectorGradeData.filter(item => item.value > 0)}
                                    color="stemiGrade"
                                    xField="type"
                                    yLabel="value"
                                    series="group"
                                    yAxisLabel="No of participants"
                                    xAxisLabel="Grade"
                                    isStack={false}
                                />
                                // <GroupColumnChart data={olympiadSectorGradeData} xLabel='type' yLabel='value' series="group" yAxisLabel="Olympiads" xAxisLabel="Grade" />
                            )}
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }

    function Tab3() {
        return (
            <div className="report-content map">
                <Row span={25} style={{ paddingBottom: 30 }} gutter={16}>
                    <Col xs={24} md={24}>
                        <Card
                            title="Geographic distribution of Olympiads in terms of Provinces"
                            bordered={false}
                            className="nysOrigin"
                            extra={
                                <Tooltip title={olympiadProvincialDistribution}>
                                    <InfoCircleTwoTone />
                                </Tooltip>
                            }
                            actions={
                                provincialDistributionData.length > 0 && [
                                    <ReportButtons
                                        onPrint={() =>
                                            handleGeoPrint(
                                                "Geographic distribution of Olympiads in terms of Provinces",
                                                olympiadMunicialDistribution,
                                                provincialDistributionData,
                                                reportTypeEnum.GEO_PROVINCES,
                                                "Olympiads"
                                            )
                                        }
                                        onDownload={() =>
                                            handleDataDownload(
                                                provincialDistributionData,
                                                "Participants per Province",
                                                reportTypeEnum.GEO_PROVINCES
                                            )
                                        }
                                    />,
                                ]
                            }
                        >
                            <ProvinceEventsMap
                                data={provincialDistributionData}
                                hoverText={olympiadProvincialDistribution}
                                dataSource="Olympiads"
                            />
                            <Legend />
                        </Card>
                    </Col>
                </Row>
                <Row span={25} style={{ paddingBottom: 30 }} gutter={16}>
                    <Col xs={24} md={24}>
                        <Card
                            title="Geographic distribution of Olympiads in terms of Municipal boundaries"
                            bordered={false}
                            className="nysOrigin"
                            extra={
                                <Tooltip title={olympiadMunicialDistribution}>
                                    <InfoCircleTwoTone />
                                </Tooltip>
                            }
                            actions={
                                municipalDistributionData.length > 0 && [
                                    <ReportButtons
                                        onPrint={() =>
                                            handleGeoPrint(
                                                "Geographic distribution of Olympiads in terms of Municipal boundaries",
                                                olympiadMunicialDistribution,
                                                municipalDistributionData,
                                                reportTypeEnum.GEO_MUNICIPALS,
                                                "Olympiads"
                                            )
                                        }
                                        onDownload={() =>
                                            handleDataDownload(
                                                municipalDistributionData,
                                                "Participants per Province",
                                                reportTypeEnum.GEO_MUNICIPALS
                                            )
                                        }
                                    />,
                                ]
                            }
                        >
                            <DistrictMap
                                data={municipalDistributionData}
                                hoverText={olympiadMunicialDistribution}
                                dataSource="Olympiads"
                            />
                            <Legend />
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }

    function Tab4() {
        return (
            <div className="report-content map">
                <Row span={25} style={{ paddingBottom: 30 }} gutter={16}>
                    <Col xs={24} md={24}>
                        <Card
                            title="Geographic distribution of participants in terms of Provinces"
                            bordered={false}
                            className="nysOrigin"
                            extra={
                                <Tooltip title={olympiadProvincialParticipation}>
                                    <InfoCircleTwoTone />
                                </Tooltip>
                            }
                            actions={
                                provincialParticipationData.length > 0 && [
                                    <ReportButtons
                                        onPrint={() =>
                                            handleGeoPrint(
                                                "Geographic distribution of participants in terms of Provinces",
                                                olympiadProvincialParticipation,
                                                provincialParticipationData,
                                                reportTypeEnum.GEO_PROVINCES,
                                                "Participants"
                                            )
                                        }
                                        onDownload={() =>
                                            handleDataDownload(
                                                provincialParticipationData,
                                                "Participants per Province",
                                                reportTypeEnum.GEO_PROVINCES
                                            )
                                        }
                                    />,
                                ]
                            }
                        >
                            <ProvinceEventsMap
                                data={provincialParticipationData}
                                hoverText={olympiadProvincialParticipation}
                                dataSource="Participants"
                            />
                            <Legend />
                        </Card>
                    </Col>
                </Row>
                <Row span={25} style={{ paddingBottom: 30 }} gutter={16}>
                    <Col xs={24} md={24}>
                        <Card
                            title="Geographic distribution of participants in terms of Municipal boundaries"
                            bordered={false}
                            className="nysOrigin"
                            extra={
                                <Tooltip title={olympiadMunicipalParticipation}>
                                    <InfoCircleTwoTone />
                                </Tooltip>
                            }
                            actions={
                                municipalParticipationData.length > 0 && [
                                    <ReportButtons
                                        onPrint={() =>
                                            handleGeoPrint(
                                                "Geographic distribution of participants in terms of Municipal boundaries",
                                                olympiadMunicipalParticipation,
                                                municipalParticipationData,
                                                reportTypeEnum.GEO_MUNICIPALS,
                                                "Participants"
                                            )
                                        }
                                        onDownload={() =>
                                            handleDataDownload(
                                                municipalParticipationData,
                                                "Participants per Province",
                                                reportTypeEnum.GEO_MUNICIPALS
                                            )
                                        }
                                    />,
                                ]
                            }
                        >
                            <DistrictMap
                                data={municipalParticipationData}
                                hoverText={olympiadMunicipalParticipation}
                                dataSource="Participants"
                            />
                            <Legend />
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }

    const tabList = [
        {
            key: "Participant demographic distribution",
            label: tab1,
            children: <Tab1 />,
        },
        {
            key: "Participant sector distribution",
            label: tab2,
            children: <Tab2 />,
            overview: true
        },
        {
            key: "Olympiad geographic distribution",
            label: tab3,
            children: <Tab3 />,
        },
        {
            key: "Participant geographic distribution",
            label: tab4,
            children: <Tab4 />,
        },
    ].filter((item) => {
            return props.reportType === "Overview" ? item : item.overview === undefined;
        });

    const onTabChange = (key) => {

        switch (key) {
            case "Participant demographic distribution":
                getParticipantDisabilityData(reportYear, olympiadRound);
                getParticipantRaceData(reportYear, olympiadRound);
                getParticipantGenderData(reportYear, olympiadRound);
                break;
            case "Participant sector distribution":
                // getProvincialDistributionData(reportYear, olympiadRound);
                // getMunicipalDistributionData(reportYear, olympiadRound);
                break;
            case "Olympiad geographic distribution":
                getProvincialDistributionData(reportYear, olympiadRound);
                getMunicipalDistributionData(reportYear, olympiadRound);
                break;
            case "Participant geographic distribution":
                getProvincialParticipationData(reportYear, olympiadRound);
                getMunicipalParticipationData(reportYear, olympiadRound);
                break;
            default:
                break;
        }
    };

    return (
        <>
            <div className="report-nys-content">
                <h2 className="report-heading">{`STEMI Olympiad ${props.reportType}  Report`}</h2>
                <div className="reportYear">
                    <Row
                        style={{
                            borderRadius: "10px",
                        }}
                    >
                        <Col
                            xs={8}
                            md={8}
                            style={{
                                borderRadius: "10px",
                            }}
                        >
                            <div className="reportYearContainer">
                                <div
                                    style={{
                                        margin: "0px auto",
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                    }}
                                >
                                    Financial year : &nbsp;
                                    {/* <DatePicker
                                        picker="year"
                                        onChange={handleChange}
                                        disabledDate={disabledDate}
                                        defaultValue={dayjs((reportYear).toString(), monthFormat)}
                                        format={monthFormat}
                                        allowClear={false}
                                    /> */}
                                    <Select
                                        // style={{ width: "65%" }}
                                        placeholder="Please select financial year"
                                        onChange={onYearChange}
                                        loading={!financialYears.length}
                                        value={reportYear}
                                        size="large"
                                    >
                                        {financialYears?.map((year) => {
                                            return (
                                                    <Option key={year.id} value={year.id}>
                                                        {year.value}
                                                    </Option>
                                            );
                                        })}
                                    </Select>
                                </div>
                            </div>
                        </Col>

                        {props.reportType === "Competition" && (
                            <Col xs={8} md={8} lg={8}>
                                <div className="report-venue-type">
                                    <div
                                        style={{
                                            margin: "10px auto 0px auto",
                                            fontSize: "16px",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        Olympiad name :&nbsp;
                                        <Select
                                            style={{ width: "65%" }}
                                            placeholder="Please select Olympiad"
                                            onChange={onChangeOlympiad}
                                        >
                                            {stemiOlympiadNames.map((event) => {
                                                return (
                                                    <Option key={event.key} value={event.value}>
                                                        {event.value}
                                                    </Option>
                                                );
                                            })}
                                        </Select>
                                    </div>
                                </div>
                            </Col>
                        )}
                        {props.reportType === "Sector" && (
                            <Col xs={8} md={8} lg={8}>
                                <div className="report-venue-type">
                                    <div
                                        style={{
                                            margin: "10px auto 0px auto",
                                            fontSize: "16px",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        Olympiad sector :&nbsp;
                                        <Select
                                            style={{ width: "65%" }}
                                            placeholder="Please select sector"
                                            onChange={onChangeSector}
                                        >
                                            {stemiOlympiadSectors.map((event) => {
                                                return (
                                                    <Option key={event.key} value={event.value}>
                                                        {event.value}
                                                    </Option>
                                                );
                                            })}
                                        </Select>
                                    </div>
                                </div>
                            </Col>
                        )}

                        <Col xs={8} md={8} lg={8}>
                            <div className="report-venue-type">
                                <div
                                    style={{
                                        margin: "10px auto 0px auto",
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                    }}
                                >
                                    Olympiad round :&nbsp;
                                    <Select
                                        style={{ width: "65%" }}
                                        placeholder="Please select round"
                                        onChange={onChangeRound}
                                    >
                                        {stemiOlympiadRounds.map((event) => {
                                            return (
                                                <Option key={event.key} value={event.value}>
                                                    {event.value}
                                                </Option>
                                            );
                                        })}
                                    </Select>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
            <div className="space"></div>
            <Tabs
                type="card"
                className="event-information"
                onChange={onTabChange}
                items={tabList}
                key="1"
            />
            <ReportTemplate
                onCancel={handlePrintCancel}
                reportOutProps={reportOutProps}
                show={show}
                key="reportStemi"
                isGeo={isGeo}
            />
        </>
    );
};